import { PDADataService } from "./base/PDADataService";

export interface ActTemplateVariableDto {
  Name: string;
  Description: string;
}

/** Сервис для получения списка переменных шаблона акта (для подстановки в блоки). */
export class ActTemplateVariablesService extends PDADataService {
  protected prefixUrl = "ActTemplateVariables";

  Fetch() {
    return this.api.get<ActTemplateVariableDto[]>(`${this.prefixUrl}/Fetch`);
  }
}
